import React from 'react';

import Icon from '../Icon/Icon';

const VibrateDisabledRestrictedIcon = (props) => {
    return (
        <Icon width='64' height='64' fill='none' {...props}>
            <path
                d='M36 30.667h-.667L33.6 33.333l-4 5.867c-.4.667-.267 1.467.4 1.867.267.133.533.266.8.266.4 0 .8-.266 1.067-.533l5.333-8c.267-.4.267-.933 0-1.333-.267-.4-.667-.8-1.2-.8zM30.533 30.667l4-5.867c.4-.667.267-1.467-.4-1.867-.666-.4-1.466-.266-1.866.4l-5.334 8a1.21 1.21 0 0 0 0 1.334c.267.4.667.666 1.2.666h3.734l1.733-2.666h-3.067z'
                fill='#34303D'
            />
            <path
                d='M26.934 41.467c-.134 0-.267 0-.4-.134-.267-.266-.4-.666-.134-.933l11.734-17.6c.266-.267.666-.4.933-.133.267.266.4.666.133.933L27.467 41.2c-.133.133-.267.267-.533.267z'
                fill='#232029'
            />
        </Icon>
    );
};

export default VibrateDisabledRestrictedIcon;
